import type { SignUpEvent } from './types';
import { getStoredUTMParams } from './utm';

/**
 * Pushes a sign_up event to Google Tag Manager dataLayer with stored UTM parameters.
 *
 * @returns void
 */
export function pushSignUpEvent(): void {
  if (typeof window === 'undefined') return;

  // Ensure dataLayer exists
  if (!window.dataLayer) {
    console.warn('[GTM] dataLayer not found. Sign-up event not tracked.');
    return;
  }

  try {
    const utmParams = getStoredUTMParams();

    const event: SignUpEvent = {
      event: 'sign_up',
      ...utmParams,
    };

    window.dataLayer.push(event);

    console.log('[GTM] Sign-up event pushed:', event);
  } catch (error) {
    console.error('[GTM] Failed to push sign-up event:', error);
  }
}
